import gql from 'graphql-tag'

const query = gql`
	query listShops {
		cashAssist {
			listShops {
				items {
					id
					name
					codePrefix
				}
				hasNextPage
			}
		}
	}
`

export default query
